import { Translations } from '@/types/types';
import { QueryKey } from '@/configs/queryKeys';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AttributeViewType {
	TILES = 'TILES',
	SEGMENT = 'SEGMENT',
	SELECT = 'SELECT',
	TEXTAREA = 'TEXTAREA',
	COLOR = 'COLOR',
}

export enum AttributeTarget {
	HANDLE = 'MAIN',
	POSTS = 'POSTS',
	ENDINGS = 'ENDINGS',
	ACCESSORIES = 'ACCESSORIES',
	STEP_ACCESSORIES = 'STEP_ACCESSORIES',
}

export interface Attribute extends BaseEntity {
	name: string;
	description: string;
	viewType: AttributeViewType;
	listOrder: number;
	isColor: boolean;
	target: AttributeTarget;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AttributeApi extends EntityApi<Attribute> {
	constructor() {
		super(QueryKey.attributes);
	}
}

export default new AttributeApi();
